module.exports = __webpack_public_path__ + "img/products.45eccccd.svg";